var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBackCirclePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    transform: "rotate(-180 16 16)",
    stroke: "#4F4FFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7468 11.2387C18.4177 10.9204 17.89 10.9204 17.5609 11.2387L13.2532 15.4054C12.9156 15.7319 12.9156 16.2681 13.2532 16.5946L17.5609 20.7613C17.89 21.0796 18.4177 21.0796 18.7468 20.7613C19.0844 20.4347 19.0844 19.8986 18.7468 19.5721L15.0538 16L18.7468 12.4279C19.0844 12.1014 19.0844 11.5653 18.7468 11.2387Z",
    fill: "#4F4FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackCirclePurple);
export default __webpack_public_path__ + "static/media/icon_back_circle_purple.6670e65bfd331532e8614b9d323166e0.svg";
export { ForwardRef as ReactComponent };